import { render, staticRenderFns } from "./input-password.vue?vue&type=template&id=b852e772&"
import script from "./input-password.vue?vue&type=script&lang=js&"
export * from "./input-password.vue?vue&type=script&lang=js&"
import style0 from "./input-password.vue?vue&type=style&index=0&id=b852e772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports